import { RefObject, useEffect } from 'react'

/**
 * Calls the provided callback when a mousedown occurs outside the referenced element.
 *
 * @param ref React ref to the HTMLElement container to detect outside clicks for
 * @param callback Function to call when an outside click is detected
 */
export default function useClickOutside(ref: RefObject<HTMLElement>, callback: () => void): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const node = ref.current
      if (node && !node.contains(event.target as Node)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}
